module.exports = __webpack_public_path__ + "static/media/feature_pict_2.358603a0.svg";